export const rgbToHex = (r: number, g: number, b: number) =>
  "#" +
  [r, g, b]
    .map(x => x.toString(16).padStart(2, "0"))
    .join("");
